(() => {
  const sync = (group) => {
    const input = group.querySelector('input');
    const minimum = Number(input.min) || 1;
    const value = Number(input.value);
    group.querySelector('[data-quantity-change="-1"]').disabled = !Number.isFinite(value) || value <= minimum;
    const plus = group.querySelector('[data-quantity-change="1"]');
    plus.disabled = !!input.max && value >= Number(input.max);
  };
  const init = () => document.querySelectorAll('[data-quantity-selector]').forEach(sync);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-change]');
    if (!button) return;
    const group = button.closest('[data-quantity-selector]');
    const input = group.querySelector('input');
    if (!input.validity.valid) input.value = input.min || '1';
    if (Number(button.dataset.quantityChange) > 0) input.stepUp(); else input.stepDown();
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    sync(group);
  });
  document.addEventListener('input', (event) => {
    const group = event.target.closest('[data-quantity-selector]');
    if (group) sync(group);
  });
  document.addEventListener('shopify:section:load', init);
  init();
})();